export default __webpack_public_path__ + "static/media/portrait4.5a83aa1c.webp";